export { FunctionRegistry } from "@cogo/runtime-v2"
export type { ExpressionFunction, FunctionParam } from "@cogo/runtime-v2"
